import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import history from '../history';

import login from './newComponents/login';
import formStart from './newComponents/formStart';
import formTermCond from './newComponents/formTermCond';
import formBusinessTeam from './newComponents/formBusinessTeam';
import inttroApp from './newComponents/intro';
import dashboard from './newComponents/dashboard';
import Header from './newComponents/header';
import profile from './newComponents/profile';
import flow from './newComponents/flow';
import Hupp from './newComponents/hupper';


class App extends React.Component {

    render() {
        return (
            <div className="ui container" style={{height: '100vh', overflowY: 'auto'}} >
                <Router history={history}>
                    <div>
                     <Header/>
                        <Switch>
                            <Route path="/" exact component={login} />
                            <Route path="/dashboard" exact component={dashboard} />
                            <Route path="/home" exact component={inttroApp} />
                            <Route path="/formulario" exact component={formStart} />
                            <Route path="/formulario/inicio" exact component={formBusinessTeam} />
                            <Route path="/formulario/termcond" exact component={formTermCond} />
                            <Route path="/profile" exact component={profile} />
                            <Route path="/newworkflow" exact component={flow} />
                        </Switch>
                    </div>
                </Router>
                <Hupp/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
       // movil: state.mainReucer.movil,
    }
};

export default connect(mapStateToProps, {  })(App);

